// Error Handling and Monitoring Utilities

// Default error collector (for development)
const defaultErrorCollector = (error, context) => {
  console.error('[Error Report]', error, context);
};

// Error reporting service
window.errorReporting = {
  collector: defaultErrorCollector,
  errors: [],
  
  // Initialize with a custom collector service
  initialize(collector) {
    if (typeof collector === 'function') {
      this.collector = collector;
    } else {
      console.warn('Invalid error collector provided, using default');
    }
    
    // Clear stored errors
    this.errors = [];
    
    console.log('Error reporting initialized');
    return this;
  },
  
  // Report an error
  reportError(error, context = {}) {
    const timestamp = new Date();
    
    // Add environment info
    const errorInfo = {
      timestamp,
      error: {
        message: error.message || String(error),
        stack: error.stack,
        name: error.name
      },
      context: {
        url: window.location.href,
        userAgent: navigator.userAgent,
        ...context
      }
    };
    
    // Store error info locally
    this.errors.push(errorInfo);
    
    // Send to collector function
    try {
      this.collector(error, errorInfo);
    } catch (e) {
      console.error('Error in error collector:', e);
    }
    
    return errorInfo;
  },
  
  // Get collected errors
  getErrors() {
    return this.errors;
  },
  
  // Clear collected errors
  clearErrors() {
    const count = this.errors.length;
    this.errors = [];
    return count;
  }
};

// Export a global report error function
window.reportError = (error, context) => window.errorReporting.reportError(error, context);

// Initialize basic error monitoring
document.addEventListener('DOMContentLoaded', () => {
  // Attach to unhandled rejections
  window.addEventListener('unhandledrejection', (event) => {
    window.reportError(event.reason, { type: 'unhandledRejection' });
  });
  
  console.log('Global error monitoring activated');
});

// For ES modules
export const reportError = window.reportError;
export const errorReporting = window.errorReporting;
